"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaCircularSpinner = _interopRequireDefault(require("@thinkific/toga-circular-spinner"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _LoadingSuccessButton = _interopRequireDefault(require("./LoadingSuccessButton.css"));

var _constants = _interopRequireWildcard(require("./constants"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_LoadingSuccessButton["default"]);

var LoadingSuccessButton = function LoadingSuccessButton(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      disabled = _ref.disabled,
      hasSuccessDisabled = _ref.hasSuccessDisabled,
      iconColor = _ref.iconColor,
      iconName = _ref.iconName,
      loadingChildren = _ref.loadingChildren,
      spinnerColor = _ref.spinnerColor,
      state = _ref.state,
      successChildren = _ref.successChildren,
      props = _objectWithoutProperties(_ref, ["appearance", "children", "disabled", "hasSuccessDisabled", "iconColor", "iconName", "loadingChildren", "spinnerColor", "state", "successChildren"]);

  var childrenComponent;
  var iconStyle = {
    backgroundColor: iconColor
  };
  var isDisabled = disabled || hasSuccessDisabled;

  if (state === _constants.LOADING) {
    childrenComponent = /*#__PURE__*/_react["default"].createElement("div", {
      className: cx('btn-loading__container')
    }, /*#__PURE__*/_react["default"].createElement(_togaCircularSpinner["default"], {
      className: cx('btn-loading__spinner', "".concat(appearance, "--spinner")),
      color: spinnerColor
    }), /*#__PURE__*/_react["default"].createElement("div", null, loadingChildren || children));
  } else if (state === _constants.SUCCESS) {
    childrenComponent = /*#__PURE__*/_react["default"].createElement("div", {
      className: cx('btn-loading__container')
    }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
      className: cx('btn-loading__success-icon', "".concat(appearance, "--icon")),
      name: iconName,
      style: iconStyle
    }), /*#__PURE__*/_react["default"].createElement("div", null, successChildren || children));
  } else {
    childrenComponent = /*#__PURE__*/_react["default"].createElement("div", null, children);
  }

  return /*#__PURE__*/_react["default"].createElement(_togaButton["default"], _extends({
    appearance: appearance,
    disabled: isDisabled
  }, props), childrenComponent);
};

LoadingSuccessButton.propTypes = {
  appearance: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming
  hasSuccessDisabled: _propTypes["default"].bool,
  iconColor: _propTypes["default"].string,
  iconName: _propTypes["default"].string,
  loadingChildren: _propTypes["default"].node,
  spinnerColor: _propTypes["default"].string,
  state: _propTypes["default"].oneOf(_constants["default"]),
  successChildren: _propTypes["default"].node
};
LoadingSuccessButton.defaultProps = {
  appearance: null,
  disabled: false,
  hasSuccessDisabled: true,
  iconColor: null,
  iconName: 'checkmark',
  loadingChildren: null,
  spinnerColor: null,
  state: _constants.LOADING,
  successChildren: null
};
var _default = LoadingSuccessButton;
exports["default"] = _default;